import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { ButtonMiniFabComponent } from 'src/app/features/shared/controls/container/button-mini-fab/button-mini-fab.component';
import { pageMode } from 'src/app/infrastructure/models/page-mode';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { TabListService } from 'src/app/features/shared/central-page/services/tab-list.service';
import { showAnimation } from 'src/app/infrastructure/animations/show-animation';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

/**
 * Minimale fallback-footer voor tabs zonder eigen list-footer (bv. Theme-editor-panelen):
 * tab-sectie tonen/verbergen, positie resetten en pagina bewerken. Heeft géén PagerService nodig
 * (die wordt per list-tablist geprovide), in tegenstelling tot TablistFooterComponent, waardoor
 * de filter-knoppen hier ontbreken.
 */
@Component({
    selector: 'app-tab-footer',
    templateUrl: './tab-footer.component.html',
    styleUrls: ['./tab-footer.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ButtonMiniFabComponent,
        SharedModule,
    ],
    animations: [
        showAnimation,
    ],
})
export class TabFooterComponent
{
    private readonly _tabListService = injectRequired(TabListService);

    tabVisible$$ = this._tabListService.tabVisible$$;
    tabPositionOffStandard$$ = this._tabListService.tabPositionOffStandard$$;
    locked$$ = this._tabListService.locked$$;
    sectionDetails_show$$ = this._tabListService.sectionDetails_show$$;
    // btnEditData$$ is al claim-gated (claimName.btnPageEdit_Show) en hide-genormaliseerd in _CentralPageService.
    btnEditShow$$ = computed(() => !this._tabListService.btnEditData$$().hide);
    // Disabled = recht aanwezig maar op deze omgeving vergrendeld (zie _CentralPageService.__sectionButton_setAuth).
    btnEditDisabled$$ = computed(() => this._tabListService.btnEditData$$().disabled);
    btnEditTooltip$$ = computed(() => this._tabListService.btnEditData$$().tooltip || 'edit page');
    // Zonder tabs is de toggle-knop zinloos → verbergen (zelfde gedrag als TablistFooterComponent).
    show$$ = this._tabListService.hasList$$;

    emit_editShow(): void {
        this._tabListService.pageMode_set(pageMode.editPage);
    }

    emit_positionReset(): void {
        this._tabListService.position_reset();
    }

    emit_tabHide(): void {
        this._tabListService.position_hide();
    }

    emit_tabShow(): void {
        this._tabListService.position_restore();
    }
}
